import _ from 'lodash'
import React, {useCallback,} from 'react'
import {getResponseItem, LoadingWrapper} from '../../Shared'
import {bindQueryParam, mapPathParam} from '../functions/routerHelper'
import useAsync from "../../../modules/asyncCache/useAsync";
import {PermissionEntity} from "../Permissions/PermissionEntity";
import {getId} from "../../../apis/model/base";
import {catholicHousehold_getById_Api} from "../../../apis/catholicHousehold";
import CatholicHouseholdEntity from "./CatholicHouseholdEntity";

const CatholicHouseholdContext = React.createContext({})


export const CatholicHouseholdProvider = ({
                                            item,
                                            children,
                                            ...props
                                          }) => {

  const apiInfo = catholicHousehold_getById_Api

  const id = getId(item) || item

  const cacheId = mapPathParam(apiInfo.path, {id})

  const {response, isLoading = false} = useAsync({
    apiInfo,
    query: bindQueryParam({id}),
  })

  const isSucceed = Number(_.get(response, 'status')) === 200

  const cache = getResponseItem(response)

  const error = getResponseItem(response, 'error')

  const errorMessage = _.get(response, 'errorMessages.error')

  const error_code = _.get(response, 'errorMessages.error_code')

  const status = {
    title: getResponseItem(response, 'status'),
    description: errorMessage,
  }


  const renderHeader = useCallback((action, isModal) => null, [])

  return (
    <LoadingWrapper isLoading={!item}>
      <CatholicHouseholdEntity
        key={cacheId}
        item={id}>
        {(item) => {

          return (
            <PermissionEntity item={item}>
              <CatholicHouseholdContext.Provider
                value={{
                  id,
                  isLoading,
                  item,
                  error,
                  cache,
                  status,
                  isSucceed,
                  error_code,
                  renderHeader,
                  errorMessage,
                  ...props,
                }}>
                {children}
              </CatholicHouseholdContext.Provider>
            </PermissionEntity>
          )
        }}
      </CatholicHouseholdEntity>
    </LoadingWrapper>
  )
}

export default CatholicHouseholdContext
